import './index.css'

import 'lazysizes'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import { defineComponents } from './scripts/utils/define-components'
import './scripts/components/animations/animations'

if (Shopify.designMode) {
  document.documentElement.className = `${document.documentElement.className} is-editor-mode`
}

defineComponents()
